var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRainBird(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Rainbird_dis",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      #Rainbird_dis .cls-1, #Rainbird_dis .cls-3 {\n        fill: #c3c3c3;\n      }\n\n      #Rainbird_dis .cls-2 {\n        clip-path: url(#Rainbird_dis-clip-path);\n      }\n\n      #Rainbird_dis .cls-3 {\n        fill-rule: evenodd;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "Rainbird_dis-clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 20,
    height: 20.286,
    transform: "translate(0 0)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-847 -710.047)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1172.94,375.825a16,16,0,1,1,16-16A16.017,16.017,0,0,1,1172.94,375.825Zm0-30.28a14.28,14.28,0,1,0,14.28,14.28A14.3,14.3,0,0,0,1172.94,345.546Z",
    transform: "translate(-309.939 366.222)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(852 715)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M19.439,15.43s.043-1.462-.692-1.934a3.817,3.817,0,0,0-1.943-.3,11.841,11.841,0,0,1-.475-1.418.662.662,0,0,1,.388-.816l1.6-1.548a5.84,5.84,0,0,0,.519-2.235c0-1.2-.3-1.633-.389-1.633S12.829,0,12.744,0c0,0,1.512,1.935,1.122,2.622-.432.774-1.425.129-1.425.129s1.468,1.333,1.037,2.106c-.259.473-1.339-.086-1.339-.086s1.685,1.118,1.3,2.02c-.3.645-1.425.43-1.425.43s1.727,1.29.431,2.106c-.95.6-4.4-3.051-4.4-3.051L5.529,2.321S5.7,4.943,5.1,5.545C4.493,6.1.95,6.276.95,6.276L6.22,8.425s4.406,4.169,3.586,4.856-2.29-.6-2.29-.6.648,1.2.216,1.505c-.475.3-2.2-.817-2.246-.9-.086-.086.432,1.246,0,1.418-.777.3-2.117-1.2-2.117-1.2s.691.9.087,1.376C2.851,15.3,0,14.183,0,14.183l8.164,5.588a4.779,4.779,0,0,0,2.16.515c.692,0,1.3-.9,1.3-.9s3.154-4.685,3.586-4.815a1.287,1.287,0,0,1,.907.215,8.488,8.488,0,0,0,1.123,1.2c.3.129.993.344.993.344L20,16.719Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRainBird);
export default __webpack_public_path__ + "static/media/rain-bird.76a105b0c058225623bfb6bc3f12cf34.svg";
export { ForwardRef as ReactComponent };